import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Card from 'bundles/apex/card';
import LeaseTerms from 'bundles/apex/deals/lease_terms';
import { hasLeaseTerms } from 'bundles/apex/deals/lease_terms/helpers';

import './styles.scss';

export function DealLeaseTermsCard({ deal, features, transactionSideOptions }) {
  if (!hasLeaseTerms(deal)) {
    return null;
  }

  return (
    <Card className="deal-lease-terms-card" fullWidth label="Rent Schedule">
      <LeaseTerms
        deal={deal}
        enableOperatingExpenses={features.operatingExpenses}
        readOnly
        transactionSideOptions={transactionSideOptions}
      />
    </Card>
  );
}

DealLeaseTermsCard.propTypes = {
  deal: PropTypes.object.isRequired,
  features: PropTypes.shape({
    operatingExpenses: PropTypes.bool,
  }).isRequired,
  transactionSideOptions: PropTypes.array,
};

const mapStateToProps = state => ({
  deal: state.deal,
  features: state.features,
  transactionSideOptions: state.options.transactionSide,
});

export default connect(mapStateToProps)(DealLeaseTermsCard);
